import { Checkbox, CheckboxProps, forwardRef } from '@chakra-ui/react';
import { ChangeEvent, useCallback } from 'react';

export type CheckboxInputProps = Omit<CheckboxProps, 'value' | 'onChange'> & {
    value: boolean;
    onChange: (value: boolean) => void;
};

const CheckboxInput = forwardRef<CheckboxInputProps, 'input'>(
    ({ value, onChange, children, ...props }, ref) => {
        const handler = useCallback(
            (e: ChangeEvent<HTMLInputElement>) => {
                onChange(e.target.checked);
            },
            [onChange]
        );
        return (
            <Checkbox {...props} isChecked={value} onChange={handler} ref={ref}>
                {children}
            </Checkbox>
        );
    }
);

export default CheckboxInput;
